import axiosInstance from '../api/axiosInstance';

// Unified login for Owner, Manager and Dining Associate
export const loginUser = async (emailMobile: string, password: string) => {
  const response = await axiosInstance.post('/auth/login', { emailMobile, password });
  const { token, role, restaurantGuid, id, name, restaurantName, restaurantLogoUrl } = response.data;
  // let logoUrl = restaurantLogoUrl
  //               ? restaurantLogoUrl.startsWith('http')
  //                 ? restaurantLogoUrl
  //                 : `${process.env.REACT_APP_API_BASE}/${restaurantLogoUrl.replace(/^\/+/g, '')}`
  //               : '';
  // Store auth info in localStorage for later use
  localStorage.setItem('token', token);
  // localStorage.setItem('role', role);
  localStorage.setItem('restaurantGuid', restaurantGuid);
  // localStorage.setItem('restaurantName', restaurantName);
  localStorage.setItem('restaurantLogoUrl', restaurantLogoUrl);
  // localStorage.setItem('userId', id);
  // localStorage.setItem('userName', name);
  localStorage.setItem('Dinelyt_session', JSON.stringify({ token, role, restaurantGuid, userId: id, userName:name, restaurantName, restaurantLogoUrl: restaurantLogoUrl }));
  return response.data;
};
